export class AllocationsFileError extends Error {
  public messageKey: string;
  public messageData: Record<string, string> | undefined;

  constructor(message: string, messageKey: string, messageData?: Record<string, string>) {
    super(message);

    this.messageKey = messageKey;
    this.messageData = messageData;
  }
}
